export interface IExploreTile {
  title: string;
  url: string;
  imageUrl: string;
  imageAlt: string;
}

// Style images are reused from the /interior-designers Prismic doc (by_style group).
export const EXPLORE_BY_STYLE: IExploreTile[] = [
  {
    title: 'Bohemian',
    url: '/exp/bohemian-design-ideas',
    imageUrl: 'https://images.prismic.io/havenly-cms/Z6vLx5bqstJ9-gOB_bohemian.jpg?auto=format,compress&rect=0,0,759,759&w=460&h=460',
    imageAlt: 'Bohemian interior design',
  },
  {
    title: 'Contemporary',
    url: '/exp/contemporary-design-ideas',
    imageUrl: 'https://images.prismic.io/havenly-cms/Z6vOOJbqstJ9-gPX_contemporary.jpg?auto=format,compress&rect=0,0,778,778&w=460&h=460',
    imageAlt: 'Contemporary interior design',
  },
  {
    title: 'Eclectic',
    url: '/exp/eclectic-design-ideas',
    imageUrl: 'https://images.prismic.io/havenly-cms/Z6vPM5bqstJ9-gQF_eclectic.jpg?auto=format,compress&rect=0,0,778,778&w=460&h=460',
    imageAlt: 'Eclectic interior design',
  },
  {
    title: 'Farmhouse',
    url: '/exp/farmhouse-design-ideas',
    imageUrl: 'https://images.prismic.io/havenly-cms/Z6vQWpbqstJ9-gQl_farmhouse.jpg?auto=format,compress&rect=0,0,778,778&w=460&h=460',
    imageAlt: 'Farmhouse interior design',
  },
  {
    title: 'Glam',
    url: '/exp/glam-design-ideas',
    imageUrl: 'https://images.prismic.io/havenly-cms/Z6vQc5bqstJ9-gQn_glam.jpg?auto=format,compress&rect=0,0,778,778&w=460&h=460',
    imageAlt: 'Glam interior design',
  },
];

export const EXPLORE_BY_ROOM: IExploreTile[] = [
  {
    title: 'Living Room',
    url: '/exp/living-room-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/living-room-design-ideas.jpeg',
    imageAlt: 'Living room design ideas',
  },
  {
    title: 'Bedroom',
    url: '/exp/bedroom-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bedroom-design-ideas.jpeg',
    imageAlt: 'Bedroom design ideas',
  },
  {
    title: 'Dining Room',
    url: '/exp/dining-room-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/dining-room-design-ideas.jpeg',
    imageAlt: 'Dining room design ideas',
  },
  {
    title: 'Nursery',
    url: '/exp/nursery-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/nursery-design-ideas.jpeg',
    imageAlt: 'Nursery design ideas',
  },
  {
    title: 'Home Office',
    url: '/exp/office-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/office-design-ideas.jpeg',
    imageAlt: 'Home office design ideas',
  },
];
